import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-3 items-center justify-center w-full h-full"
}
const _hoisted_3 = { class: "rounded-md bg-red-50 p-4 w-full" }
const _hoisted_4 = { class: "flex flex-col items-start gap-2 md:flex-row md:items-center" }
const _hoisted_5 = { class: "flex items-start gap-2" }
const _hoisted_6 = { class: "flex flex-col md:flex-row items-start gap-1" }
const _hoisted_7 = { class: "text-sm font-medium text-red-700" }
const _hoisted_8 = {
  key: 2,
  class: "grid grid-cols-12 md:gap-10"
}
const _hoisted_9 = {
  key: 0,
  class: "col-span-12 md:pb-12 flex flex-col items-center justify-center gap-6"
}
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "flex items-center justify-center absolute -left-3 w-[100px] h-[100px] rounded-full border border-theme-gray-7" }
const _hoisted_12 = { class: "flex flex-col gap-1 md:w-[80%] mx-auto" }
const _hoisted_13 = { class: "rounded-md bg-green-50 p-4" }
const _hoisted_14 = { class: "flex flex-col items-start gap-2 md:flex-row md:items-center" }
const _hoisted_15 = { class: "flex items-start gap-2" }
const _hoisted_16 = { class: "flex flex-col md:flex-row items-start gap-1" }
const _hoisted_17 = { class: "text-sm font-medium text-green-800" }
const _hoisted_18 = {
  key: 1,
  class: "col-span-12 md:pb-12 flex flex-col items-center justify-center gap-6"
}
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "flex items-center justify-center absolute -left-3 w-[100px] h-[100px] rounded-full border border-theme-gray-7" }
const _hoisted_21 = { class: "text-center flex flex-col gap-1 md:w-[80%]" }
const _hoisted_22 = { class: "rounded-md bg-yellow-50 p-4" }
const _hoisted_23 = { class: "flex flex-col items-start gap-2 md:flex-row md:items-center" }
const _hoisted_24 = { class: "flex items-start gap-2" }
const _hoisted_25 = { class: "flex flex-col md:flex-row items-start gap-1" }

import { ref, onMounted } from 'vue'
import LoaderIcon from '@/components/LoaderIcon.vue'
import { handleApiError, clearSessionData, getBookingNumber, getPaymentSession, getPaymentTransaction, getPaymentCode, isLoggedIn, getDealId, getPaymentWallet, canPayViaCredit } from '@/utils/common'
import Payment from '@/composables/Payment'
import BookingService from '@/services/booking-service'
import { useRouter } from 'vue-router'
import CarService from '@/services/car-service'
import Loader from '@/widgets/Loader.vue'
import BookingVoucher from '@/pages/BookingVoucher.vue'
import Deal from '@/composables/Deal'
import BookingCreditService from '@/services/booking-credit-service'


export default /*@__PURE__*/_defineComponent({
  __name: 'Finish',
  props: ['currentStep'],
  setup(__props) {

const props = __props
const isLoading = ref<boolean>(true)
const hasError = ref<boolean>(false)
const booking : string | null = getBookingNumber()
const transaction : string | null = getPaymentTransaction()
const session : string | null = getPaymentSession()
const cvc : string | null = getPaymentCode()
const paymentWallet: string | null = getPaymentWallet()
const { authorizePayment  } = Payment()
const payload = ref<any>(null)
const responsee = ref<any>(null)
const { finalizeeBooking  } = BookingService()
const feed = ref<any>()
const feedType = ref<'success' | 'error'>()
const router = useRouter()
const { retrieveUserSelectedCar } = CarService()
const bookingNumber = ref<string>()
const dealId = ref<string>()
const message = ref<string>('Booking has been complete and payment has been recieved')
const errorMessage = ref<string>('')
const authUser = isLoggedIn()
const { getCredit, withdrawFromCreditt } = BookingCreditService()
const { createDeal, updateDeal, createContact } = Deal()

onMounted(async () => {
   
   bookingNumber.value = getBookingNumber() as string
   dealId.value = getDealId() as string

   if (bookingNumber.value == null || bookingNumber.value == '') {
      router.push({name: 'Home'})
   } else {

      const carResponse: any = retrieveUserSelectedCar()
      if (carResponse && (carResponse.price == null || carResponse.price == 0)) {
         
         feedType.value = 'success'
         const finalResponse = await finalizeeBooking(bookingNumber.value, feedType.value, {}, true)
         isLoading.value = false
         if (finalResponse.success) {
   
            await upsertDeal()
            message.value = 'Your request has been created. You will be contacted by our representative shortly.'
            clearSessionData()
         } else {
            hasError.value = true
         }
      } else {

         if (paymentWallet == 'card') {

            const response = await authorizePayment(session, booking, transaction, cvc as string)
            if (response.status == 200) {
         
               const responsee = response.data.response
         
               if (
                  !responsee || 
                  !responsee.response || 
                  !responsee.response.gatewayCode || 
                  responsee.response.gatewayCode != 'APPROVED' || 
                  !responsee.result || 
                  responsee.result != 'SUCCESS'
               ) {
                  feed.value = responsee
                  feedType.value = 'error'
               } else {
                  feed.value = responsee.order
                  feedType.value = 'success'
               }
         
               const finalResponse = await finalizeeBooking(bookingNumber.value, feedType.value, feed.value, false)
               isLoading.value = false
               
               await upsertDeal()
   
               if (finalResponse.success) {
         
                  message.value = 'A booking has been created and payment has been received'
                  clearSessionData()
               } else {
                  hasError.value = true
                  errorMessage.value = 'We encountered an error while processing your payment'
               }
            } else {
               
               isLoading.value = false
               hasError.value = true
               errorMessage.value = handleApiError(response)
            }
         } else if (paymentWallet == 'apple_pay') {

            feedType.value = 'success'
            feed.value = 'apple_pay'
            const finalResponse = await finalizeeBooking(bookingNumber.value, feedType.value, feed.value, false)
            isLoading.value = false
            
            //await upsertDeal()

            if (finalResponse.success) {
      
               message.value = 'A booking has been created and payment has been received'
               clearSessionData()
            } else {
               hasError.value = true
               errorMessage.value = 'We encountered an error while processing your payment'
            }
         } else if (paymentWallet == 'credit') {
            
            const creditResponse = await getCredit(bookingNumber.value)
            if (creditResponse && creditResponse.success && canPayViaCredit(creditResponse.data.credit)) {

               const withdrawResponse = await withdrawFromCreditt(bookingNumber.value)
               if (withdrawResponse.success) {

                  feedType.value = 'success'
                  feed.value = 'credit'
                  const finalResponse = await finalizeeBooking(bookingNumber.value, feedType.value, feed.value, false)
                  isLoading.value = false
      
                  await upsertDeal()
      
                  if (finalResponse.success) {
      
                     message.value = 'A booking has been created and payment has been made through your credit wallet'
                     clearSessionData()
                  } else {
                     hasError.value = true
                     errorMessage.value = 'We encountered an error while creating a booking for you'  
                  }
               } else {
                  hasError.value = true
                  errorMessage.value = withdrawResponse.message
               }
            } else {
               hasError.value = true
               errorMessage.value = 'You are not authorized to pay through your credit wallet'
            }
         } else {
            hasError.value = true
            errorMessage.value = 'Unknown payment wallet'
         }
      }
   }
})

const upsertDeal = async () => {

   const booking = parseInt(bookingNumber.value as string)
   const deal = parseInt(dealId.value as string)

   if (authUser && (authUser.user.type == 'agent' || authUser.user.type == 'corporate')) {
      
      await updateDeal(deal, booking)
   } else {

      await createContact(booking)
      await createDeal(booking)
   }
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (hasError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-theme-gray-5 text-head-md-2 md:text-head-xl text-center flex flex-col gap-3 mb-3" }, [
              _createElementVNode("div", null, "Error")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "lg",
                    icon: "fa-solid fa-times-circle",
                    class: "text-red-400"
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(errorMessage.value), 1),
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'Home'}))),
                      class: "font-medium text-sm text-red-700 underline hover:text-red-600 cursor-pointer"
                    }, "Go to home")
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (feedType.value == 'success')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "2xl",
                        icon: "fa-solid fa-check",
                        class: "text-theme-active"
                      })
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-theme-gray-1 w-[100px] h-[100px] rounded-full" }, null, -1))
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-theme-gray-5 text-head-md-2 md:text-head-xl text-center flex flex-col gap-3" }, [
                    _createElementVNode("div", null, "Thank You")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_font_awesome_icon, {
                            size: "lg",
                            icon: "fa-solid fa-check-circle",
                            class: "text-green-400"
                          }),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(message.value), 1),
                            _createElementVNode("div", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({name: 'Home'}))),
                              class: "font-medium text-sm text-green-700 underline hover:text-green-600 cursor-pointer"
                            }, "Go to home")
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(BookingVoucher, { bookingNumber: bookingNumber.value }, null, 8, ["bookingNumber"])
                ]))
              : (feedType.value == 'error')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_font_awesome_icon, {
                          size: "2xl",
                          icon: "fa-solid fa-check",
                          class: "text-theme-active"
                        })
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "bg-theme-gray-1 w-[100px] h-[100px] rounded-full" }, null, -1))
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-theme-gray-5 text-head-md-2 md:text-head-xl text-center flex flex-col gap-3" }, [
                      _createElementVNode("div", null, "Thank You")
                    ], -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "lg",
                              icon: "fa-solid fa-circle-exclamation",
                              class: "text-yellow-400"
                            }),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-medium text-yellow-700" }, " A booking has been created for you but we did not receive payment from your bank. You will be contacted by our representative for further assistance ", -1)),
                              _createElementVNode("div", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({name: 'Home'}))),
                                class: "font-medium text-sm text-yellow-700 underline hover:text-yellow-600 cursor-pointer"
                              }, "Go to home")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ])),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"])
  ], 64))
}
}

})